<template>

  <v-card v-if="availCar">

    <!-- image -->
    <v-img v-if="isSmallDevice" class="mb-n5" height="200px" :src="carImg"
           v-on:error="carImg = 'car-models/no-car-image.png'" tile/>

    <v-row class="pa-5" no-gutters>
      <!-- car id -->
      <v-col cols="12" sm="4">
        <!-- image -->
        <v-img class="ma-n5" v-if="!isSmallDevice" width="300px" height="200px" :src="carImg"
               v-on:error="carImg = 'car-models/no-car-image.png'" tile/>
        <!-- car model -->
        <v-card-title class="text-h5" v-text="availCar.model"></v-card-title>
        <!-- car category -->
        <v-card-subtitle v-text="availCar.category"></v-card-subtitle>
      </v-col>
      <!-- car options -->
      <v-col cols="12" sm="5">
        <div v-for="carOption of carOptions" :key="carOption.id" class="ma-2"
             :class="{'d-inline-block': isSmallDevice}">
          <CarOptionChip :option="carOption" :hideText="isSmallDevice"></CarOptionChip>
        </div>
      </v-col>
      <!-- booking info -->
      <v-col cols="12" sm="3" class="d-flex flex-column">
        <div align="end" v-if="availCar.prix&& availCar.prix.length>0">
          <!-- price unit -->
          <div>{{$t('booking.availability_car_card.price_for')}} : {{ availCar.prix[0].libele }} {{ availCar.prix[0].prixUnite |
            currency }}
          </div>
          <!-- total -->
          <div>{{$t('booking.availability_car_card.total_price')}} : <b style="font-size: 1.22em;">{{ availCar.prix[0].ttc |
            currency }}</b></div>
          <div v-if="availCar.cautions">{{$t('booking.availability_car_card.deposit')}} : <b style="font-size: 1.22em;">{{ availCar.cautions[0].ttc |
            currency }}</b></div>
        </div>
        <!-- book button -->
        <div class="flex-grow-1 d-flex flex-row-reverse align-end pa-0">
          <v-btn @click.prevent="startBookingProcess" class="bookButton mt-2">
            {{$t('booking.availability_car_card.book')}}
            <v-icon class="ml-2">mdi-bookmark</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

  </v-card>

</template>

<script>
  import CarOptionChip from "./CarOptionChip";
  import { CarOption } from '../models';

  export default {
    props: {
      availCar: null
    },
    data () {
      return {
        carOptions: [
          new CarOption({ id: 'car-category', color: 'blue', icon: 'mdi-car-info', text: this.availCar.category }),
          new CarOption({
            id: 'car-type',
            color: 'blue',
            icon: 'mdi-car-cog',
            text: this.$options.filters.carType(this.availCar.type)
          }),
          new CarOption({ id: 'nbr-place', color: 'green', icon: 'mdi-car-seat', text: this.availCar.nbrPlace }),
          new CarOption({
            id: 'agency',
            color: 'purple',
            icon: 'mdi-office-building-marker',
            text: this.availCar.agency ? this.availCar.agency.name + ' (' + this.availCar.agency.address + ')' : ''
          }),
          new CarOption({ id: 'tenant', color: 'blue', icon: 'mdi-office-building', text: this.availCar.tenantName}),
        ],
        carImg: 'car-models/' + this.availCar.model.replace(' ', '-') + '.jpg'
      };
    },
    methods: {
      startBookingProcess () {
        const bookingContext = this.$store.getters['booking/context'];
        bookingContext.availabilityCar = this.availCar;
        this.$store.commit('booking/setContext', bookingContext);
        this.$router.push({ name: 'booking' });
      }
    },
    created (){

    },
    components: { CarOptionChip }
  };
</script>

<style scoped>
  .flexy {
    position: absolute;
    bottom: .3rem;
    right: .3rem;
  }

  .bookButton {
    color: white;
    background-color: indigo !important;
    border: 1px solid transparent;
  }

  .bookButton:hover {
    color: indigo;
    border: 1px solid indigo;
    background-color: white !important;
    transition: background-color .5s;
  }
</style>
